"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDaysOfWeek = void 0;
require("../../../core");
const getDaysOfWeek = (days, map) => {
    const result = [];
    for (let i = 0; i <= days.length; i++) {
        const day = map.get(days[i]);
        if (day) {
            result.push(day);
        }
    }
    return result;
};
exports.getDaysOfWeek = getDaysOfWeek;
//# sourceMappingURL=getDaysOfWeek.js.map